import clsx from "clsx";
import { ElementType } from "react";

import * as style from "./Svg.css";

export interface SvgProps extends React.ComponentPropsWithoutRef<"svg"> {
  svg: ElementType;
}

export default function Svg({ svg, className, ...props }: SvgProps) {
  const Component = svg;

  return <Component className={clsx(style.svg, className)} {...props} />;
}
